"use client";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "@crehana/i18n";
import { clsx } from "clsx";
import Avatar from "../../Avatar/Avatar.js";
import { Popper, PopperContent, PopperTrigger } from "../Popper/index.js";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../Tooltip/index.js";
import i18n, { AVATAR_GROUP } from "./i18n/index.js";
const AvatarGroup = ({ avatars, size = 's', hideLabel, containerAvatarsClass = 'tw-bg-neutral-light-100 tw-rounded-full tw-px-0.8 tw-py-0.2 tw-border-solid tw-border  tw-border-neutral-light-400', removePortalFromPopper = false, label })=>{
    const { addResourceBundle, t } = useTranslation(AVATAR_GROUP);
    addResourceBundle(i18n);
    return /*#__PURE__*/ jsx(Fragment, {
        children: avatars.length > 0 && /*#__PURE__*/ jsxs(Fragment, {
            children: [
                !hideLabel && /*#__PURE__*/ jsxs("div", {
                    className: "tw-mb-1",
                    children: [
                        /*#__PURE__*/ jsx("span", {
                            className: "tw-font-link1 tw-mr-0.4",
                            children: label || t('MEMBERS')
                        }),
                        /*#__PURE__*/ jsxs("span", {
                            className: "tw-font-body5 tw-text-neutral-light-700",
                            children: [
                                "(",
                                avatars.length,
                                ")"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ jsx(Popper, {
                    children: /*#__PURE__*/ jsxs("div", {
                        className: clsx('tw-flex  tw-w-fit', containerAvatarsClass),
                        children: [
                            avatars.slice(0, 4).map((avatar, index)=>/*#__PURE__*/ jsx("div", {
                                    className: clsx('tw-cursor-pointer tw-border-solid tw-border-0.4 tw-border-neutral-light-100 tw-rounded-full tw-relative', 0 != index && 'tw-ml-[-1.4rem]'),
                                    children: /*#__PURE__*/ jsx(TooltipProvider, {
                                        children: /*#__PURE__*/ jsxs(Tooltip, {
                                            delayDuration: 500,
                                            children: [
                                                /*#__PURE__*/ jsx(TooltipTrigger, {
                                                    className: "tw-text-neutral-light-800 dark:tw-text-neutral-light-100",
                                                    children: /*#__PURE__*/ jsx(Avatar, {
                                                        size: size,
                                                        src: avatar.src
                                                    })
                                                }),
                                                /*#__PURE__*/ jsx(TooltipContent, {
                                                    align: "center",
                                                    side: "top",
                                                    children: avatar.userName
                                                })
                                            ]
                                        })
                                    })
                                }, avatar.userName)),
                            /*#__PURE__*/ jsx(PopperTrigger, {
                                type: "button",
                                className: "tw-z-1",
                                children: avatars.length > 4 && /*#__PURE__*/ jsxs("span", {
                                    className: " tw-ml-[-14px] tw-static tw-outline tw-outline-neutral-light-100 tw-font-link1 tw-text-neutral-light-700 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border-solid tw-border tw-border-neutral-light-500 tw-h-3.2 tw-w-3.2 tw-bg-neutral-light-300 tw-cursor-pointer",
                                    children: [
                                        "+",
                                        avatars.length - 4
                                    ]
                                })
                            }),
                            /*#__PURE__*/ jsx(PopperContent, {
                                align: 'center',
                                side: 'bottom',
                                className: "tw-py-1.2 tw-px-1.6 tw-h-16.4 tw-overflow-auto tw-max-w-24",
                                removePortal: removePortalFromPopper,
                                children: /*#__PURE__*/ jsx("div", {
                                    className: "tw-space-y-1.2",
                                    children: avatars.slice(4, avatars.length).map((avatar, index)=>/*#__PURE__*/ jsxs("div", {
                                            className: "tw-flex tw-items-center",
                                            children: [
                                                /*#__PURE__*/ jsx(Avatar, {
                                                    size: size,
                                                    src: avatar.src
                                                }),
                                                /*#__PURE__*/ jsx("span", {
                                                    className: "tw-font-body5 tw-ml-0.8 tw-truncate",
                                                    children: avatar.userName
                                                })
                                            ]
                                        }, index))
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
export { AvatarGroup };
